import './force-sw-reload-modal.scss'

import { defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue'

import { reactiveVueMixin } from "@skinsoft/reactive-vue"
import { FORCE_UPDATE_SERVICE_WORKER_TOPIC } from '@skinsoft/bus/src/busTopics'

declare const BUILD_ISO_DATE: string
declare const VERSION: string

export const ForceSwReloadModal = defineComponent({
    mixins: [reactiveVueMixin],
    template: require('./force-sw-reload-modal.html'),
    data() {
        return {
            version: VERSION,
            buildDate: new Date(BUILD_ISO_DATE),
        }
    },
    methods: {
        forceUpdateServiceWorker() {
            this.emitOnBus(FORCE_UPDATE_SERVICE_WORKER_TOPIC)
            ;(this.$refs.modal as BModal).hide()
        },

        update() {
            // @ts-ignore
            location.reload(true)
        },

        openModal() {
            (this.$refs.modal as BModal).show()
        },
    },
})
